// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"162":"5536c62e","184":"ece1b487","501":"36dd163c","754":"2e86df11","983":"1271d540"}[chunkId] + ".chunk.js";
};